import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PrimaryButton, Stack } from '@fluentui/react';
import { useColumnSelect } from '../Provider/useColumnSelect';
import { ColumnSelectReset } from './ColumnSelectReset';
/**
 * The footer for the ColumnSelectPanel, including the close button.
 */
export const ColumnSelectPanelFooter = ({ labelCloseButton = 'Close', propsResetButton = {}, }) => {
    const { setOpen } = useColumnSelect();
    return (_jsxs(Stack, Object.assign({ horizontal: true, horizontalAlign: 'end', verticalAlign: 'center', tokens: { childrenGap: '1em', padding: '0.5em' } }, { children: [_jsx(ColumnSelectReset, Object.assign({}, propsResetButton)), _jsx(PrimaryButton, Object.assign({ iconProps: { iconName: 'Checkmark' }, onClick: () => setOpen(false) }, { children: labelCloseButton }))] })));
};
